import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'
import {SingleColumnMenu} from 'src/shared/components/header-menu/SingleColumnMenu'
import {appConfig, i18n} from 'src/shared/config'

const prefix = appConfig.lang === 'ru' ? '/ru' : ''

export const controlPanel = [
  {
    button: {
      label: i18n('order.header.button.become-a-courier', 'Стать курьером'),
    },
    list: [
      {
        href: prefix + '/for-courier/',
        label: i18n('order.header.button.on-foot-courier', 'Пешим курьером'),
      },
      {
        href: prefix + '/for-courier/personal-car/',
        label: i18n('order.header.button.auto-courier', 'Автокурьером'),
      },
    ],
  },
]

const cargoMenu = css`
  padding-inline-start: ${spacing(26.5)}; // 212px
`

const expressMenu = css`
  padding-inline-start: ${spacing(51)}; // 408px
`

const expressMenuKk = css`
  padding-inline-start: ${spacing(55)}; // 440px
`

export const linksList = [
  {
    label: i18n('order.header.link.cargo-delivery', 'Грузовая доставка'),
    content: (
      <div className={cargoMenu}>
        <SingleColumnMenu
          key="cargo"
          links={[
            {
              text: i18n('order.header.link.moving', 'Переезд'),
              id: 'move-flat',
              items: [
                {
                  text: i18n(
                    'order.header.link.move-flat',
                    'Квартирный переезд',
                  ),
                  href: prefix + '/move-flat/',
                },
              ],
            },
            {
              text: i18n('order.header.move', 'Перевозка'),
              id: 'move',
              items: [
                {
                  text: i18n(
                    'order.header.link.move-things',
                    'Перевозка вещей',
                  ),
                  href: prefix + '/move-things/',
                },
                {
                  text: i18n(
                    'order.header.link.move-furniture',
                    'Перевозка мебели',
                  ),
                  href: prefix + '/move-furniture/',
                },
              ],
            },
          ]}
        />
      </div>
    ),
  },
  {
    label: i18n('order.header.link.express-delivery', 'Экспресс-доставка'),
    content: (
      <div className={appConfig.lang === 'kk' ? expressMenuKk : expressMenu}>
        <SingleColumnMenu
          key="express-delivery"
          links={[
            {
              text: i18n(
                'order.header.link.express-delivery',
                'Экспресс-доставка',
              ),
              id: 'express-delivery',
              items: [
                {
                  text: i18n(
                    'order.header.link.parcels',
                    'Доставка отправлений',
                  ),
                  href: prefix + '/parcels/',
                },
              ],
            },
          ]}
        />
      </div>
    ),
  },
]

export const linksListMobile = [
  {
    id: 'main',
    passOnClick: true,
    list: [
      {
        id: 'cargo',
        label: i18n('order.header.link.cargo-delivery', 'Грузовая доставка'),
      },
      {
        id: 'express',
        label: i18n('order.header.link.express-delivery', 'Экспресс-доставка'),
      },
      {
        id: 'become-a-courier',
        label: i18n('order.header.button.become-a-courier', 'Стать курьером'),
      },
    ],
  },
  {
    id: 'become-a-courier',
    list: controlPanel[0].list,
  },
  {
    id: 'cargo',
    list: [
      {
        label: i18n('order.header.link.move-flat', 'Квартирный переезд'),
        href: prefix + '/move-flat/',
      },
      {
        label: i18n('order.header.link.move-things', 'Перевозка вещей'),
        href: prefix + '/move-things/',
      },
      {
        label: i18n('order.header.link.move-furniture', 'Перевозка мебели'),
        href: prefix + '/move-furniture/',
      },
    ],
  },
  {
    id: 'express',
    list: [
      {
        label: i18n('order.header.link.parcels', 'Доставка отправлений'),
        href: prefix + '/parcels/',
      },
    ],
  },
]
